/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./game-difficulty-select.vue?vue&type=template&id=5691adff&scoped=true&"
import script from "./game-difficulty-select.vue?vue&type=script&lang=js&"
export * from "./game-difficulty-select.vue?vue&type=script&lang=js&"
import style0 from "./game-difficulty-select.vue?vue&type=style&index=0&id=5691adff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5691adff",
  null
  
)

export default component.exports